// prefixes included in CyberSource gateway error messages (from Paradox Labs)
const invalidCreditCardPrefixRegex = /^Unable to place order: Invalid credit card/
const transactionFailedPrefixRegex = /^Unable to place order: Transaction Failed:/
// decline message shape from older Paradox Labs versions
const gatewayRequestErrorPrefixRegex = /^Unable to place order: Cybersource Gateway request error/i

export const isCyberSourceGatewayError = (errorMessage: string): boolean =>
  transactionFailedPrefixRegex.test(errorMessage)
export const isCyberSourceValidationError = (errorMessage: string): boolean =>
  invalidCreditCardPrefixRegex.test(errorMessage)
export const isPaymentDeclinedError = (errorMessage: string): boolean =>
  isCyberSourceGatewayError(errorMessage) ||
  isCyberSourceValidationError(errorMessage) ||
  gatewayRequestErrorPrefixRegex.test(errorMessage)

// Magento refuses to place, merge or start over on a cart whose Shop Pay payment is in progress
// with this stable prefix (DFH-117, DFH-122); the rest of the message is the shopper's copy.
export const shopPayCartLockedPrefix = 'SHOPPAY_CART_LOCKED'
export const isShopPayCartLockedError = (errorMessage: string): boolean =>
  errorMessage.startsWith(shopPayCartLockedPrefix)
